import { VuexModule, Action, Module, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import homeSmartApi from '@/plugins/HomeSmartApi';
import { SearchResponseData } from '@/modules/backend/Dto/SearchResponseData';
import { SearchEntityType, SearchRequestData } from '@/modules/backend/Dto/SearchRequestData';

interface SetEntityPayloadInterface {
  entity: SearchEntityType;
  state: boolean;
}

@Module({ store, dynamic: true, name: 'search' })
export class SearchModule extends VuexModule {
  loading = false;
  entities: SearchEntityType[] = ['companies', 'buildings', 'locations', 'accounts', 'counters'];
  items: SearchResponseData = new SearchResponseData({});

  public get entityIsSelected(): (entity: SearchEntityType) => boolean {
    return (entity: SearchEntityType): boolean => this.entities.includes(entity);
  }

  public get availableEntities(): SearchEntityType[] {
    return ['companies', 'buildings', 'locations', 'accounts', 'counters'];
  }

  @Action
  toggleEntity(entity: SearchEntityType): void {
    this.context.commit('setEntity', {
      entity,
      state: !this.entityIsSelected(entity)
    });
  }

  @Action
  async search(query: string): Promise<void> {
    this.context.commit('setLoading', true);
    const response = await homeSmartApi.Search.search(new SearchRequestData({
      entities: this.entities,
      query: encodeURI(query),
    }));

    this.context.commit('setItems', response);
    this.context.commit('setLoading', false);
  }

  @Mutation
  setEntities(payload: SearchEntityType[]): void {
    this.entities = payload;
  }

  @Mutation
  setItems(payload: SearchResponseData): void {
    this.items = payload;
  }

  @Mutation
  clearItems(): void {
    this.items = new SearchResponseData({});
  }

  @Mutation
  setEntity(payload: SetEntityPayloadInterface): void {
    if (payload.state) {
      this.entities = [...this.entities, payload.entity];
    } else {
      this.entities = this.entities.filter(entry => entry !== payload.entity);
    }
  }

  @Mutation
  setLoading(state: boolean): void {
    this.loading = state;
  }
}
